/* @flow */

export const IMAGE_UPDATED: string = 'news@images:IMAGE_UPDATED';
export const IMAGE_DELETED: string = 'news@images:IMAGE_DELETED';
export const CATCH_IMAGE_UPDATED: string = 'news@images:CATCH_IMAGE_UPDATED';
export const CATCH_IMAGE_DELETED: string = 'news@images:CATCH_IMAGE_DELETED';

export const updateImage = (image: CatalogResource) => ({
  type: IMAGE_UPDATED,
  image,
});

export const deleteImage = () => ({
  type: IMAGE_DELETED,
});

export const updateCatchImage = (image: CatalogResource) => ({
  type: CATCH_IMAGE_UPDATED,
  image,
});

export const deleteCatchImage = () => ({
  type: CATCH_IMAGE_DELETED,
});



// WEBPACK FOOTER //
// ./src/modules/news/actions/images.js